import { API_CONSTS } from "../../constants";

const axios = require("axios").default;

export const getAuthorizeCodes = async (applicationId: string) => {
  const controller = new AbortController();
  const abortTimeoutId = setTimeout(() => controller.abort(), 8000);
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_API_URL}/${API_CONSTS.AUTH_API_PATH}/authorize`,
      method: "get",
      responseType: "json",
      headers: {
        "Content-Type": "application/json",
        "x-application": applicationId,
      },
      signal: controller.signal,
      withCredentials: true,
    });

    clearTimeout(abortTimeoutId);

    if (response.status !== 200) return null;

    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
